import React from 'react';
import {useNavigate} from 'react-router-dom';
import classes from './CreateReceipt.module.scss'
import ButtonCreateReceipt from "./ButtonCreateReceipt/ButtonCreateReceipt";

const CreateReceipt: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={classes['create-group-form']}>
      <ButtonCreateReceipt handleOpen={() => navigate('/create/scanned')}/>
    </div>
  );
};

export default CreateReceipt;
